<template>
  <div class="layout">
    <AppHeader />
    
    <main>
      <router-view></router-view>
    </main>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  name: "DefaultLayout",
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

